import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import sanitize from 'sanitize-html';

import LoadingPage from '@/components/common/LoadingPage';
import SubPageHeader from '@/components/common/SubPageHeader';
import { toDateString } from '@/lib/utils/date';

import useSelectedParty from '../analysis/hooks/useSelectedParty';

import useNote from './queries/hooks/useNote';

export default function NoteDetail() {
  const { t } = useTranslation();
  const { id } = useParams<{ id?: string }>();

  const party = useSelectedParty();

  const { data: note, isLoading } = useNote(party?.id ?? '', id ?? '', {
    enabled: Boolean(party?.id) && Boolean(id),
  });

  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <SubPageHeader>
        <span>{t('NOTE_DETAIL_TITLE')}</span>
      </SubPageHeader>

      <main className="min-h-0 flex-1">
        {isLoading && <LoadingPage />}

        {!isLoading && note && (
          <div className="mt-1 flex h-full flex-col">
            <div className="flex shrink-0 justify-between border-b p-2">
              <span className="text-sm">{note.broker_name}</span>

              <span className="text-muted-foreground text-sm">
                {toDateString(note.created_at)}
              </span>
            </div>

            <div className="min-h-0 flex-1">
              <div
                className="h-full overflow-auto p-2 text-xs"
                dangerouslySetInnerHTML={{ __html: sanitize(note.text) }}
              />
            </div>
          </div>
        )}
      </main>
    </div>
  );
}
